module.exports = __webpack_public_path__ + "img/marketing.0cb77d89.jpeg";